<template>
  <div>
    <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px">
          <div class="level" style="width:100%">
            <div class="level-left">
              <v-btn icon @click="$router.replace({ name: 'Playlists' })">
                <v-icon large>keyboard_arrow_left</v-icon>
              </v-btn>
              <h1 class="title">{{playlist.name}}</h1>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button icon-left="edit" class="button is-info level-item" @click="editPlaylist($route.params.id)">Edit</b-button>
              </div>
              <div class="level-item">
                <b-button icon-left="trash" class="button is-danger level-item" @click="confirmRemove">Remove</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-table :data="tableData.length > 0 ? tableData : []" striped>
        <template slot-scope="props">
          <b-table-column field="name" label="Name" centered>
            {{props.row.name}}
          </b-table-column>
          <b-table-column field="id" label="Type" centered>
            {{props.row.type}}
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="window-close"
                  size="is-medium">
                </b-icon>
              </p>
              <p>No items to display.</p>
            </div>
          </section>
        </template>
      </b-table>

      <v-divider></v-divider>
  </div>
</template>

<script>
import PlaylistAddEdit from '@/components/playlists/PlaylistAddEdit'

export default {
  name: 'PlaylistDetails',
  data: () => {
    return {
      tableData: []
    }
  },
  computed: {
    playlist () {
      let id = this.$route.params.id
      return this.$store.getters.getPlaylist(id)
    },
    workspaceId () {
      return this.$store.state.workspaceId
    }
  },
  watch: {
    playlist (items) {
      this.tableData = []
      for (let item in this.playlist.items) {
        this.tableData.push({ id: item, ...this.playlist.items[item] })
      }
    }
  },
  mounted: function () {
    for (let item in this.playlist.items) {
      this.tableData.push({ id: item, ...this.playlist.items[item] })
    }
  },
  methods: {
    confirmRemove () {
      this.$buefy.dialog.confirm({
        title: 'Delete playlist',
        message: 'Are you sure you want to <b>delete</b> this platlist? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => this.removePlaylist()
      })
    },
    removePlaylist () {
      let id = this.$route.params.id
      let relatedClustersRef = this.$store.getters.getClustersForPlaylist(id)
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        for (let cluster in relatedClustersRef) {
          this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId + '/' + cluster).update({
            mainPlaylistId: ''
          })
        }
      } else {
        for (let cluster in relatedClustersRef) {
          this.$store.state.database.ref('/clusters/' + this.$store.state.uid + '/' + cluster).update({
            mainPlaylistId: ''
          })
        }
      }
      let removePlaylistRef = null
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        removePlaylistRef = this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + id)
      } else {
        removePlaylistRef = this.$store.state.database.ref('/playlists/' + this.$store.state.uid + '/' + id)
      }
      removePlaylistRef.remove()
      let removePlaylistFilesRef = null
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + id)
      } else {
        removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + id)
      }
      removePlaylistFilesRef.listAll().then(dir => {
        dir.items.forEach(fileRef => {
          fileRef.delete().then(() => {
            this.globalLogger('deleted file' + fileRef.name)
          })
        })
      })
      this.$router.push({ name: 'Playlists' })
    },
    editPlaylist (id) {
      this.$buefy.modal.open({
        parent: this,
        component: PlaylistAddEdit,
        props: { editEnabled: true, propId: id },
        hasModalCard: true,
        trapFocus: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/playlists/PlaylistDetails.vue